<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>Настройки SEO</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col cols="12">
            <span>Meta title (<TranslationIcon/>)</span>
            <v-text-field
              outlined
              :disabled="loading"
              v-model="fields.seoMetaTitle"

            />
          </v-col>
          <v-col cols="12">
            <span>Description (<TranslationIcon/>)</span>
            <v-text-field
              outlined
              :disabled="loading"
              v-model="fields.seoMetaDescription"
            />
          </v-col>
          <v-col cols="12">
            <span>Keywords (<TranslationIcon/>)</span>
            <v-text-field
              outlined
              :disabled="loading"
              v-model="fields.seoMetaKeywords"
            />
          </v-col>
          <v-col cols="12">
            <span>SEO disallow index</span>
            <v-switch
              inset
              dense
              :disabled="loading"
              :loading="loading"
              v-model="fields.seoDisallowIndex"
            />
          </v-col>
          <v-col cols="12">
            <span>Rel canonical</span>
            <v-text-field
              outlined
              :disabled="loading"
              v-model="fields.seoRelCanonical"
            />
          </v-col>
          <v-col cols="12">
            <span>SEO image</span>
            <MediaFilePicker
              :multiple="false"
              :file-type="$options.mediaTypesByKeys.IMAGE"
              :value="fields.seoOgImageId "
              @change="filesHandler"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import MediaFilePicker from '@/components/media-file-picker'
import FormAbstract from '@/components/abstract/form'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'

export default {
  name: 'SeoSettings',
  mediaTypesByKeys: mediaTypesByKeys(),
  components: {
    TranslationIcon,
    MediaFilePicker
  },
  extends: FormAbstract,
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      fields: {
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImageId: null
      }
    }
  },
  watch: {
    data: {
      handler (data) {
        this.populate(data)
        this.fields.seoOgImageId = data?.seoOgImage?.id || null
      }
    },
    fields: {
      deep: true,
      handler: 'onInput'
    }
  },
  methods: {
    onInput () {
      this.$emit('on-input-seo', this.fields)
    },
    filesHandler (event) {
      this.fields.seoOgImageId = event
      this.onInput()
    }
  }
}
</script>

<style lang="css" scoped>
.v-expansion-panel-content__wrap {
  padding: 0;
}
.v-expansion-panel-header {
  padding: 0;
}
</style>
